import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { UserControls } from './UserControls';
import { UserIssuerIcon } from './UserIssuerIcon';
import { UserTableEditableCell } from './UserTableEditableCell';
import { UserWithIssuerType } from '@sonar-software/sonar-core';

import { ColumnsType, ColumnType } from 'antd/es/table';

type ColumnDefinition = ColumnType<UserWithIssuerType>;

function getEmailColumn(shardName?: string): ColumnDefinition {
	return {
		dataIndex: 'email',
		key: 'email',
		render: (value: string, user: UserWithIssuerType) =>
			<div className='user-email-with-issuer'>
				<UserTableEditableCell
					editable={ user.hasUsernameAndPassword || user.ssoIssuerType === null }
					shardName={ shardName }
					userId={ user.id }
					userProperty='email'
					value={ value } />
			</div>,
		title: ADMIN_DASHBOARD_COPY.EMAIL,
		width: 400
	};
}

function getFirstNameColumn(shardName?: string): ColumnDefinition {
	return {
		dataIndex: 'firstName',
		key: 'firstName',
		render: (value: string, user: UserWithIssuerType) =>
			<UserTableEditableCell
				shardName={ shardName }
				userId={ user.id }
				userProperty='firstName'
				value={ value } />,
		title: ADMIN_DASHBOARD_COPY.FIRST_NAME,
		width: 150
	};
}

function getLastNameColumn(shardName?: string): ColumnDefinition {
	return {
		dataIndex: 'lastName',
		key: 'lastName',
		render: (value: string, user: UserWithIssuerType) =>
			<UserTableEditableCell
				shardName={ shardName }
				userId={ user.id }
				userProperty='lastName'
				value={ value } />,
		title: ADMIN_DASHBOARD_COPY.LAST_NAME,
		width: 150
	};
}

function getIdColumn(): ColumnDefinition {
	return {
		dataIndex: 'id',
		key: 'id',
		title: ADMIN_DASHBOARD_COPY.ID,
		width: 75
	};
}

function getIssuerColumn(): ColumnDefinition {
	return {
		align: 'center',
		dataIndex: 'ssoIssuerType',
		key: 'ssoIssuerType',
		render: (value: string, user: UserWithIssuerType) => <UserIssuerIcon issuerType={ user.ssoIssuerType } />,
		title: ADMIN_DASHBOARD_COPY.SSO_ISSUER,
		width: 75
	};
}

function getControlsColumn(shardName?: string): ColumnDefinition {
	return {
		dataIndex: 'actions',
		key: 'actions',
		minWidth: 715,
		render: (value: string, user: UserWithIssuerType) =>
			<UserControls
				shardName={ shardName }
				user={ user } />,
		title: ADMIN_DASHBOARD_COPY.ACTIONS
	};
}

export function getUserTableColumns(shardName?: string): ColumnsType<UserWithIssuerType> {
	return [
		getEmailColumn(shardName),
		getFirstNameColumn(shardName),
		getLastNameColumn(shardName),
		getIdColumn(),
		getIssuerColumn(),
		getControlsColumn(shardName)
	];
}

export function getUserTableRowKey(user: UserWithIssuerType, shardName?: string): string {
	return `${user.id}:${shardName}`;
}
